export default __webpack_public_path__ + "static/media/codeigniter.d89dec09.jpg";